import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PsHttpService } from '@patsnap/tahiti-core';
import type { PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import type { PackageApi, IPackageType } from '../package-api';
import { eurekaApiUrlPrefix } from '@telecom/shared/domain-config';

@injectable()
export class PackageApiImpl extends PsHttpService implements PackageApi {
    get options() {
        return {
            baseURL: eurekaApiUrlPrefix,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    async getUserPackageType(): Promise<IPackageType[]> {
        const result = await this.get<PatSnapSuccessResponseData<IPackageType[]>>({
            url: '/package-info',
            cache: true,
        });
        return result.data;
    }
}
